var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"button-wrapper",style:(_vm.cssVariables),on:{"click":_vm.routeTo}},[_c('div',{staticClass:"button",class:{
      selected: _vm.isSelected,
      raised: _vm.raised,
    }},[_c('div',{staticClass:"button-image",class:{ selected: _vm.isSelected, raised: _vm.raised, home: _vm.homeIcon },style:(_vm.imageCss)})]),_c('div',{staticClass:"button-title p2-style",class:{ home: _vm.homeIcon, selected: _vm.isSelected }},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }